import React, { memo } from 'react';
import { FileZipFilled, CloseCircleFilled } from '@ant-design/icons';
import { formatSizes } from '../../../../lib/helpers';

export const FileUploadPreview = memo(({ file, handleDelete }) => {
    return (
        <div className="file-upload-preview">
            <div>
                <FileZipFilled style={{ color: 'var(--yellow-default)', fontSize: '2rem' }} />
            </div>
            <div className="file-info">
                <span>{file.name}</span>
                <span>{formatSizes(file.size)}</span>
            </div>
            {handleDelete && <CloseCircleFilled className="close-icon" onClick={handleDelete} />}
        </div>
    );
});
